/*
 * Copyright (c) 2023 Anvilor Solutions LLC - All Rights Reserved.
 *
 * The information and source code contained herein is the exclusive property of
 * Anvilor Solutions LLC and may not be disclosed, examined, or reproduced in whole
 * or in part without the explicit written authorization from Anvilor Solutions LLC.
 */

import { ControlDefinition } from "@anvilor/ngx-rui";
import { LegacyRuiControl } from "@anvilor/ngx-rui";
import { RuiStore } from "@anvilor/ngx-rui";
import { RuiCompositeControl } from "@anvilor/ngx-rui";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { CONTROL_SURVEY_STATES } from "../survey-states-control/survey-states-control";

export const CONTROL_STANDARD_SURVEY_LAYOUT = "anvilor_forms:standard_layout";

const DEFAULT_CONTENT_MAX_WIDTH = "1000px";

export interface StandardSurveyLayoutControlDefinition extends ControlDefinition {
  control: typeof CONTROL_STANDARD_SURVEY_LAYOUT;
  main_content_max_width: string;
  items: ControlDefinition[];
  post_submit?: ControlDefinition;
  post_close?: ControlDefinition;
  pre_open?: ControlDefinition;
}

export class StandardSurveyLayoutControl
  extends LegacyRuiControl<StandardSurveyLayoutControlDefinition>
  implements RuiCompositeControl
{
  translatedControlDefinition$: Observable<ControlDefinition>;

  constructor(store: RuiStore, id: string) {
    super(store, id);

    this.translatedControlDefinition$ = this.selectors.rawDefn$.pipe(
      map((d) => {
        return {
          control: "flexbox",
          id: "_main_wrap",
          flex_direction: "column",
          align_items: "center",
          styles: {
            width: "100%",
            height: "100%",
            position: "relative",
          },
          items: [
            {
              styles: {
                "flex-grow": 1,
                width: "99vw",
                margin: "0 auto",
                "max-width": d.main_content_max_width ?? DEFAULT_CONTENT_MAX_WIDTH,
              },
              control: {
                control: CONTROL_SURVEY_STATES,
                main: {
                  control: "flexbox",
                  id: "_vbox",
                  flex_direction: "column",
                  styles: { width: "100%" },
                  item_styles: { width: "100%" },
                  items: d.items.map((control) => ({
                    styles: { width: "100%" },
                    control: control,
                  })),
                },
                post_submit: d.post_submit,
                post_close: d.post_close,
                pre_open: d.pre_open,
              },
            },
          ],
        };
      })
    );
  }
}
